export default "__VITE_ASSET__36e88165__"